import * as React from 'react';
import * as Popover from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

export const Root = Popover.Root;
export const Trigger = Popover.Trigger;

export const Content = React.forwardRef<
  React.ElementRef<typeof Popover.Content>,
  React.ComponentPropsWithoutRef<typeof Popover.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <Popover.Portal>
    <Popover.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn('z-50 w-auto rounded-md border bg-background p-3 shadow-md', className)}
      {...props}
    />
  </Popover.Portal>
));
Content.displayName = 'PopoverContent';
